<template>
  <v-container class="form-container rounded-lg">
    <h1>Edit key word</h1>
    <EditForm :fields="fields" name="keyWords" />
  </v-container>
</template>

<script>
import { markRaw } from "vue";
import TextField from "@/Admin/components/form/TextField.vue";

import { ruleSetGen } from "@/Admin/helpers/rules";
import EditForm from "@/Admin/components/EditForm.vue";
import config from "@/helpers/api";
export default {
  name: "KeywordEditView",
  components: { EditForm },
  data() {
    return {
      fields: {
        text: {
          component: markRaw(TextField),
          data: {
            label: "Name",
            placeholder: "Enter key word name",
            name: "text",
            rules: ruleSetGen.text("Enter correct key word name", true, 3),
          },
        },
      },
    };
  },
  async created() {
    await fetch(`${config.baseURL}/keyWords/${this.$route.params.id}`, {
      method: "GET",
      headers: config.headers,
    })
      .then((response) => response.json())
      .then((response) => {
        for (const key in this.fields) {
          this.fields[key].data.value = response.data[key];
        }
      });
  },
};
</script>

<style scoped>
.form-container {
  width: 1000px;
  margin: auto;
  background-color: white;
  padding: 10px;
}
</style>
